<template>
  <div class="photoframe">
    <div class="photoframe__container">
      <img
        :src="source"
        alt=""
        class="photoframe__image"
      />
      <img
        v-for="(frame, index) in frames"
        :key="`frame_${index}`"
        :src="frame.src"
        class="photoframe__frame"
        :class="`photoframe__frame_${frame.position}`"
        :style="{
          visibility: index === frameIndex ? 'visible' : 'hidden',
          margin: `${cornerMargin}px`,
        }"
        alt=""
      />
    </div>
    <template v-if="frames.length > 1">
      <button
        type="button"
        class="photoframe__arrow photoframe__arrow_prev"
        @click="$emit('prev')"
      >
        <BaseIcon
          name="back"
          class="photoframe__icon"
        />
      </button>
      <button
        type="button"
        class="photoframe__arrow photoframe__arrow_next"
        @click="$emit('next')"
      >
        <BaseIcon
          name="back"
          class="photoframe__icon"
        />
      </button>
    </template>
  </div>
</template>

<script>
import BaseIcon from '@/components/BaseIcon.vue';

export default {
  name: 'PhotoFrames',
  components: {
    BaseIcon,
  },
  props: {
    source: {
      type: String,
      required: true,
    },
    frames: {
      type: Array,
      default: () => [],
    },
    frameIndex: {
      type: Number,
      default: 0,
    },
    cornerMargin: {
      type: Number,
      default: 20,
    },
  },
};
</script>

<style lang="stylus">
.photoframe
  position relative
  display flex
  width 100%
  height 100%
  background-color inherit
  overflow hidden

  &__container
    position relative
    height 100%
    margin 0 auto

  &__image
    display block
    width auto
    height 100%

  &__frame
    display block
    position absolute
    z-index 3
    &_top
      abs top left
      width 100%
      margin 0 !important
    &_bottom
      abs bottom left
      width 100%
      margin 0 !important
    &_top_left
      abs top left
    &_top_right
      abs top right
    &_bottom_left
      abs bottom left
    &_bottom_right
      abs bottom right

  &__arrow
    abs top 50%
    width 3.6em
    height @width
    background-color $c_light
    padding 1em
    color $c_primary
    border-radius 50%
    outline none
    border 0
    margin 0
    margin-top ((@height / 2) * -1)
    z-index 5
    &_prev
      left 1.25em
    &_next
      right 1.25em
      .icon
        transform rotate(180deg)
</style>
